import { render, staticRenderFns } from "./Movie.vue?vue&type=template&id=3e652421&scoped=true"
import script from "./Movie.vue?vue&type=script&lang=js"
export * from "./Movie.vue?vue&type=script&lang=js"
import style0 from "./Movie.vue?vue&type=style&index=0&id=3e652421&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e652421",
  null
  
)

export default component.exports